import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-items":"space-between"} }
const _hoisted_2 = {
  key: 0,
  "w-100": "",
  class: "App-Acc-Top-C"
}
const _hoisted_3 = { class: "App-Acc-Top-D" }
const _hoisted_4 = {
  key: 0,
  class: "App-Acc-Top-DS"
}
const _hoisted_5 = { "mute-secondary": "" }
const _hoisted_6 = {
  key: 1,
  class: "App-Acc-Top-DS"
}
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_AccountTopBusiness = _resolveComponent("AccountTopBusiness")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_account_top_dropdown = _resolveComponent("account-top-dropdown")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    style: {"width":"100%"},
    trigger: "click"
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_account_top_dropdown, { user: _ctx.user }, null, 8, ["user"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedAccount && _ctx.clickedAccount(...args))),
        class: "App-Acc-Top"
      }, [
        _createVNode(_component_el_skeleton, {
          style: {"width":"300px"},
          loading: !_ctx.loadedUser,
          animated: ""
        }, {
          template: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_skeleton_item, {
                variant: "circle",
                style: {"width":"50px","height":"50px","margin-right":"10px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"calc(100% - 100px)","height":"20px"}
              })
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_el_avatar, {
                    src: _ctx.user.avatar,
                    class: "App-Acc-Top-Av",
                    size: 40
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.initials(_ctx.user)), 1)
                    ]),
                    _: 1
                  }, 8, ["src"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$filters.fullNames(_ctx.user)), 1),
                    (_ctx.$utils.user.isTalent(_ctx.user))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.$filters.capitalize(_ctx.user.headline || _ctx.user.type)), 1)
                        ]))
                      : (_ctx.$utils.user.isFounder(_ctx.user))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                            _createVNode(_component_AccountTopBusiness, { user: _ctx.user }, null, 8, ["user"])
                          ]))
                        : (_ctx.$utils.user.isAdmin(_ctx.user))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Admin "))
                          : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_button, {
                    class: "App-Acc-Top-Btn",
                    icon: "el-icon-setting",
                    plain: "",
                    circle: "",
                    "is-borderless": ""
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}